import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token");
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    if (!token) { setStatus("error"); setErrorMsg("Lien manquant"); return; }
    api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then((r) => {
        localStorage.setItem("dsf_customer_token", r.data.token);
        localStorage.setItem("dsf_user", JSON.stringify(r.data.user));
        setStatus("success");
        toast.success("Email confirmé !");
        setTimeout(() => navigate("/compte"), 2200);
      })
      .catch((e) => {
        setStatus("error");
        setErrorMsg(e.response?.data?.detail || "Vérification impossible");
      });
  }, [token, navigate]);

  return (
    <div className="bg-white text-[var(--dsf-text)] min-h-screen" data-testid="verify-email-page">
      <Header />
      <div className="pt-40 pb-24 px-6 text-center max-w-xl mx-auto">
        {status === "loading" && (
          <>
            <Loader2 size={42} className="text-[var(--dd-green)] mx-auto animate-spin mb-6" />
            <h1 className="font-serif text-3xl text-[var(--dd-green)] mb-3">Vérification en cours…</h1>
            <p className="text-[var(--dsf-text-muted)]">Patientez quelques secondes.</p>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 size={48} className="text-[var(--dsf-success)] mx-auto mb-6" />
            <h1 className="font-serif text-3xl md:text-4xl text-[var(--dd-green)] mb-3">Bienvenue !</h1>
            <p className="text-[var(--dsf-text-muted)]">Votre email est confirmé. Vous êtes maintenant connecté(e) et redirigé(e) vers votre compte.</p>
          </>
        )}
        {status === "error" && (
          <>
            <AlertCircle size={42} className="text-[var(--dd-coral)] mx-auto mb-6" />
            <h1 className="font-serif text-3xl text-[var(--dd-coral)] mb-3">Vérification impossible</h1>
            <p className="text-[var(--dsf-text-muted)] mb-6">{errorMsg}</p>
            <Link to="/connexion" className="btn-primary">Aller à la connexion</Link>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
